import type { ProductItemThemeSettings } from '@providers/ThemeProvider/types';

import type { ProductVendorProps } from '@/features/filter-product-list/product-list/product-item/ProductVendor';

export type ProductVendorPropsMapSettings = Pick<
  ProductVendorProps,
  'fontFamily' | 'color' | 'fontSize' | 'fontStyle' | 'textAlign' | 'textTransform'
>;

export const useConnectProductVendor = (settings: ProductItemThemeSettings) => {
  const productVendorSettings = settings.productInfo?.elements?.vendor;

  return {
    props: productVendorSettings,
  };
};
